module.exports = __webpack_public_path__ + "static/img/3.e29d783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-3/3.png
// module id = Gj4U
// module chunks = 0